import styled from 'styled-components'
import { Section, SubTitle } from './Section'
import { AccordionList } from '@favordelivery/tupperware/lib/components/section/accordion'
import { Title, Content, StyledSection } from '@favordelivery/tupperware/lib/components/section/styles'
import { mediaTablet, mediaMobile } from '../styles/breakPoints'
import { t, tStr } from '@utils/lang'

// keys are paired so each question keeps its answer; resolved at render so the
// active locale is picked up rather than the one loaded at import time
const qnaKeys = [
  'WhatIs',
  'HowWorks',
  'WhatDeliver',
  'Requirements',
  'WhatNeeded',
  'Experience',
  'HowSoon',
  'Where',
  'GetPaid',
  'Status'
]

const FaqSection = styled(Section)`
  background: var(--themeColorBetaBgBrown);
  ${Title} {
    text-transform: none;
    color: var(--themeColorBetaSecondary);
    background: var(--themeColorBetaBgBrown);
    font-size: ${p => p.theme.font.size.h4};
    font-weight: ${p => p.theme.font.weight.normal};
    letter-spacing: normal;
    > div {
      margin: 0;
      padding: 20px 0;
      border-bottom: none;
    }
  }
  ${Content} {
    margin: 0;
    padding: 0 0 20px;
    color: var(--themeColorBetaSecondary);
    font-size: ${p => p.theme.font.size.title};
    font-weight: ${p => p.theme.font.weight.light};
    line-height: ${p => p.theme.font.lineHeight};
  }
  ${StyledSection} + ${StyledSection} {
    border-top: 1px solid var(--themeColorBetaBorder);
  }
`
const FaqTitle = styled(SubTitle)`
  text-align: left;
  margin: 0;
`
const FaqList = styled(AccordionList)`
  margin: 36px 0;
  ${mediaTablet} {
    margin: 28px 0;
  }
  ${mediaMobile} {
    margin: 24px 0;
  }
`
const SeeMore = styled.div`
  color: var(--themeColorBetaSecondary);
  font-size: ${p => p.theme.font.size.body};
  font-weight: ${p => p.theme.font.weight.bold};
  line-height: ${p => p.theme.font.lineHeight};
  a {
    text-decoration: underline;
  }
  ${mediaMobile} {
    font-size: ${p => p.theme.font.size.body};
  }
`

const Faq = () => (
  <FaqSection>
    <FaqTitle as="h2">{t('faqTitle_s')}</FaqTitle>
    <FaqList
      canExpandMultiple
      sections={qnaKeys.map((key, index) => ({
        title: tStr(`faq${key}Q_s`),
        children: t(`faq${key}A_s`),
        id: `faq-${index}`
      }))}
    />
    <SeeMore>
      {t('faqSeeMore_s', { link: <a href="https://favor-runners.zendesk.com/hc/en-us">{t('faqHelpLink_s')}</a> })}
    </SeeMore>
  </FaqSection>
)

export default Faq
